const BASE_URL = process.env.REACT_APP_BASE_URL;

// Identification - APIM
export const LOGIN_ADMIN = BASE_URL + '/identification/login/admin';
export const LOGIN_ORGANIZER = BASE_URL + '/identification/login/organizer';
export const AUTH_ADMIN = BASE_URL + '/identification/authentication/admin';
export const AUTH_ORGANIZER = BASE_URL + '/identification/authentication/organizer';
export const REFRESH_TOKEN = BASE_URL + '/identification/refresh/{role}';

// Communication - APIM
export const RESET_PASSWORD = BASE_URL + '/communication/mail/resetpassword';
export const NEW_ORGANIZER_PASSWORD = BASE_URL + '/communication/changepassword/organizer';
export const NEW_ADMIN_PASSWORD = BASE_URL + '/communication/changepassword/admin';
export const NEW_PARTICIPANT_PASSWORD = BASE_URL + '/communication/changepassword/participant';

// User - APIM
export const USER_INFO = BASE_URL + '/user/{role}';
export const LIST_ADMIN = BASE_URL + '/user/list/admins';
export const LIST_ORGANIZER = BASE_URL + '/user/list/organizers';
export const CREATE_ADMIN = BASE_URL + '/user/create/admin';
export const CREATE_ORGANIZER = BASE_URL + '/user/create/organizer';
export const UPDATE_ADMIN = BASE_URL + '/user/update/admin';
export const UPDATE_ORGANIZER = BASE_URL + '/user/update/organizer';
export const UPDATE_ORGANIZER_AS_ADMIN = BASE_URL + '/user/update/organizer/admin/{organizerId}';
export const DELETE_ADMIN = BASE_URL + '/user/delete/admin/{adminId}';
export const INACTIVATE_ORGANIZER = BASE_URL + '/user/inactivate/organizer/{organizerId}';
export const ACTIVATE_ORGANIZER = BASE_URL + '/user/activate/organizer/{organizerId}';
export const INACTIVATE_ORGANIZER_PROFILE = BASE_URL + '/user/inactivate/organizerprofile/{organizerProfileId}';
export const ACTIVATE_ORGANIZER_PROFILE = BASE_URL + '/user/activate/organizerprofile/{organizerProfileId}';
export const UPDATE_PASSWORD = BASE_URL + '/user/change/{role}/password/';
export const CREATE_ORGANIZER_USER = BASE_URL + '/user/create/organizer/profile';
export const LIST_ORGANIZER_USER = BASE_URL + '/user/list/organizer/profiles';
export const GET_ORGANIZER_USER = BASE_URL + '/user/organizer/profile';
export const UPDATE_ORGANIZER_PROFILE = BASE_URL + '/user/update/organizerprofile/{organizerProfileId}';

// Competition - APIM
export const COMPETITIONS_CREATED = BASE_URL + '/list/organizer/competitions/';
export const CREATE_COMPETITION_DRAFT = BASE_URL + '/create/competition/draft/';
export const UPDATE_COMPETITION = BASE_URL + '/update/competition/';
export const DELETE_COMPETITION_DRAFT = BASE_URL + '/delete/competition/{competitionId}';
export const SINGLE_COMPETITION = BASE_URL + '/competition/organizer/{competitionId}';
export const LIST_VEHICLES = BASE_URL + '/list/vehicle/{competitionId}';
export const LIST_VEHICLE_BRANDS = BASE_URL + '/list/vehicleBrands';
export const RACING_NUMBERS = BASE_URL + '/list/registered/numbers/{competitionId}';
export const ASSIGN_RACING_NUMBERS = BASE_URL + '/update/racingnumbers/{competitionId}';
export const ADD_VEHICLE = BASE_URL + '/add/vehicle';
export const EDIT_VEHICLE = BASE_URL + '/edit/vehicle';
export const DELETE_VEHICLE = BASE_URL + '/delete/vehicle/{competitionId}/{vehicleId}';
export const COMPETITION_REGISTRATIONS = BASE_URL + '/list/registered/participants/organizer/{competitionId}';
export const COMPETITION_REGISTER = BASE_URL + '/register/manually';
export const UPDATE_RACECLASS = BASE_URL + '/update/raceclass';
export const UPDATE_REGISTRATION = BASE_URL + '/toggle/registered/participant';
export const TOGGLE_STARTLIST = BASE_URL + '/toggle/startlist';
export const LIST_STARTLIST = BASE_URL + '/list/organizer/startlist/{competitionId}';
export const TOGGLE_MULTIPLE_STARTLIST = BASE_URL + '/toggle/startlist/multiple';
export const DELETE_MULTIPLE_VEHICLES = BASE_URL + '/delete/vehicle/{competitionId}';
export const CANCEL_COMPETITION = BASE_URL + '/competition/cancel';
export const COPY_COMPETITION = BASE_URL + '/competition/copy/{competitionId}';
export const UPLOAD_VEHICLE_NUMBERS = BASE_URL + '/import/vehiclenumbers';

// Commerce - APIM
export const LIST_VEHICLES_FOR_BIDS = BASE_URL + '/commerce/list/bid/organizer/{competitionId}';
export const CHANGE_BID_STATUS = BASE_URL + '/commerce/update/bid/status';
export const REGISTER_BID = BASE_URL + '/commerce/register/manually/bid/';
export const LIST_OPEN_BIDS_COMPETITION = BASE_URL + '/commerce/list/open/bids/{competitionId}';
export const LIST_VEHICLES_OPEN_BIDS = BASE_URL + '/commerce/list/bid/organizer/{competitionId}';
export const CHANGE_MULTIPLE_BID_STATUS = BASE_URL + '/commerce/update/multiple/bid/status';

// Assets - APIM
export const ASSETS_ROOT = BASE_URL + '/assets';
export const ADD_ASSET = BASE_URL + '/assets/add/asset';
export const ADD_DOCUMENT = BASE_URL + '/assets/add/document';
export const GET_DOCUMENTS = BASE_URL + '/assets/get/documents/{competitionId}/{type}';
export const GET_DOCUMENT = BASE_URL + '/assets/get/document/{documentId}';
export const DELETE_DOCUMENT = BASE_URL + '/assets/delete/document/{documentId}';
export const GENERATE_REGISTRATIONS = BASE_URL + '/assets/excel/registrations';
export const GENERATE_STARTLIST = BASE_URL + '/assets/excel/startlist';
